module.exports = __webpack_public_path__ + "img/block2Img03.a7b98e47.png";